/* eslint-disable camelcase */
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import reduxUtils from 'util/redux';
import { connect } from 'react-redux';
import { debounce } from 'lodash';
import CmsRichText from 'components/cms-placeholder/richtext';
import imageDpiResolution from 'util/dom/image-dpi-resolution';
import staticPath from 'util/misc/static-assets-path';
import ReactPlayer from 'react-player';
import PageVisibility from 'components/page-visibility';
import VisibilitySensor from 'components/visibility-sensor';
import { VIDEO_AUTOPLAY_DEBOUNCE } from 'constants/debounce-delays';
import t from 'translations';

class CardContent extends PureComponent {
    static propTypes = {
        title: PropTypes.string,
        video: PropTypes.object,
        fallback_image: PropTypes.object,
        link: PropTypes.object,
        text: PropTypes.string,
        app_store_link: PropTypes.string,
        google_play_link: PropTypes.string,
        app_store_buttons_on_last_card: PropTypes.bool,
        visible: PropTypes.bool.isRequired,
        firstCard: PropTypes.bool,
    };

    constructor(props) {
        super(props);
        this.state = {
            video: {
                playing: false,
                loop: true,
                controls: false,
                width: '100%',
                height: 'auto',
                className: 'card-content--video',
            },
            id: Math.random(),
        };
    }

    componentWillUpdate(nextProps) {
        if (this.props.visible !== nextProps.visible) {
            this.play(nextProps.visible);
        }
    }

    handleElementVisibility = debounce(function(elVisible) {
        if (this.props.visible) {
            this.play(elVisible);
        }
    }, VIDEO_AUTOPLAY_DEBOUNCE);

    handlePageVisibility = debounce(function(visibilityState, documentHidden) {
        if (this.props.visible) {
            this.play(!documentHidden);
        }
    });

    play = (isPlaying) => {
        this.setState({
            ...this.state,
            video: {
                ...this.state.video,
                playing: isPlaying,
            },
        });
    };

    render() {
        const {
            title,
            video,
            text,
            link,
            fallback_image,
            app_store_buttons_on_last_card,
            google_play_link,
            app_store_link,
            firstCard,
        } = this.props;

        return (
            <article className="card-content">
                <h3 className="card-content--title u-reset u-reset__h2">{title}</h3>
                <div className="card-content--video-wrapper">
                    {app_store_buttons_on_last_card ? <div className="card-content--video-placeholder"></div> : (
                        <PageVisibility onChange={this.handlePageVisibility.bind(this)}>
                            <VisibilitySensor onChange={this.handleElementVisibility.bind(this)}>
                                <ReactPlayer
                                    url={[video.src_webm, video.src]}
                                    config={{
                                        file: {
                                            attributes: {
                                                poster: fallback_image.src[`@${ Math.min(imageDpiResolution(), 2) }`],
                                                autoPlay: this.state.video.playing,
                                                playsInline: true,
                                                muted: true,
                                            },
                                        },
                                    }}
                                    {...this.state.video}
                                />
                            </VisibilitySensor>
                        </PageVisibility>
                    )}
                    {app_store_buttons_on_last_card && (
                        <div className="card-content--app-store">
                            {google_play_link && (
                                <a
                                    aria-label={t('accessibility.label.buy_on_googleplay')}
                                    className="card-content--app-store-link u-reset"
                                    href={google_play_link}
                                    target="_blank"
                                >
                                    <img
                                        className="card-content--app-store-img"
                                        src={staticPath('img/logos/im-googleplay-badge.svg')}
                                    />
                                </a>
                            )}
                            {app_store_link && (
                                <a
                                    aria-label={t('accessibility.label.buy_on_appstore')}
                                    className="card-content--app-store-link u-reset"
                                    href={app_store_link}
                                    target="_blank"
                                >
                                    <img
                                        className="card-content--app-store-img"
                                        src={staticPath('img/logos/im-appstore-badge.svg')}
                                    />
                                </a>
                            )}
                        </div>
                    )}
                </div>
                <div className="card-content--text">
                    <CmsRichText value={text} className={'card-content--richtext'}/>
                </div>
                {(link && firstCard) && (
                    <div className="card-content--link">
                        {link.label}
                    </div>
                )}
            </article>
        );
    }
}

export default connect(reduxUtils.mapStateToProps({}))(CardContent);



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/components/cms-placeholder/card-stack/card-content/index.js